import PropTypes from "prop-types";
import * as React from "react";
import { observer } from "mobx-react";

import Icon from "../../../decorations/icons/icon";
import ErrorTooltip from "./errortooltip";

import {
    Footer,
    Info,
    ProgressBar,
    Wrapper,
    CancelButton,
    Status,
    StatusWrapper,
    HeaderTitle
} from "./upload.styles";

interface UploadProps {
    uploadStore: any; //TODO: needs types
    onCancel?: React.MouseEventHandler;
    isCompact?: boolean;
    displayErrorMsg?: boolean;
}

export const Upload = (props: UploadProps) => {
    const {
        uploadStore,
        onCancel,
        isCompact = false,
        displayErrorMsg = true
    } = props;

    return (
        <Wrapper>
            <Info>
                <HeaderTitle>{uploadStore.fileName}</HeaderTitle>
                {!isCompact && (
                    <ProgressBar
                        invalid={uploadStore.invalid}
                        status={uploadStore.status}
                        data-testid="upload-progress-bar"
                    >
                        <div
                            style={{
                                transform: `scaleX(${
                                    uploadStore.invalid
                                        ? 0
                                        : uploadStore.progress
                                })`
                            }}
                        />
                    </ProgressBar>
                )}
                <Footer>
                    <StatusWrapper>
                        <Status
                            status={uploadStore.status}
                            invalid={uploadStore.invalid}
                        >
                            {uploadStore.displayStatus}
                        </Status>
                        {displayErrorMsg && (
                            <ErrorTooltip upload={uploadStore} />
                        )}
                    </StatusWrapper>
                    {!isCompact && <b>{uploadStore.progressPercentage}</b>}
                </Footer>
            </Info>
            <CancelButton onClick={onCancel}>
                <Icon name="close" />
            </CancelButton>
        </Wrapper>
    );
};

export default observer(Upload);
